<form [formGroup]="editFlorderPlanningForm" class="form-container row">
  <div class="row">
    <eps-label-body
      class="col-12"
      label="ORDERS.FILTER.LABELS.SEAL_NUMBER"
      [labelWidth]="labelWidth"
      *ngIf="!panelStatus.isEdit && !panelStatus.isEditable && orderDetail.ccr && !!orderDetail.ccr.ccrNumber"
    >
      {{ orderDetail.ccr.sealNumber }}
    </eps-label-body>

    <eps-date-input
      class="col-12"
      *ngIf="!panelStatus.isEdit && !panelStatus.isEditable"
      label="ORDERS.FILTER.LABELS.ORDER_DATE"
      formControlName="orderDate"
      [labelWidth]="labelWidth"
      [readonly]="true"
    ></eps-date-input>

    <eps-date-input
      *ngIf="!panelStatus.createTemplate && !panelStatus.editTemplate"
      [inlineSuffix]="getOpeningHoursText()"
      [readonly]="!panelStatus.isEdit"
      [showErrors]="panelStatus.isEditable || panelStatus.isEdit"
      [validRanges]="validLoadingDates"
      [labelWidth]="labelWidth"
      class="col-12"
      formControlName="loadingDate"
      label="ORDERS.DETAIL.LABELS.LOADING_DATE"
    ></eps-date-input>

    <eps-date-input
      *ngIf="!panelStatus.isEdit && !panelStatus.isEditable"
      [readonly]="true"
      [showErrors]="false"
      class="col-12"
      formControlName="definitiveDate"
      label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE"
      [labelWidth]="labelWidth"
    ></eps-date-input>

    <app-florder-recurrence
      *ngIf="panelStatus.showRecurrence"
      [form]="editFlorderPlanningForm.get('recurrence')"
      [isEdit]="panelStatus.isEdit"
      [loadingDate]="editFlorderPlanningForm.value.loadingDate"
      class="col-12"
    ></app-florder-recurrence>

    <eps-select
      label="ORDERS.DELIVERY.LABELS.RECURRENCE_SINGLE"
      formControlName="singleRecurrence"
      [options]="singleRecurrenceValues"
      [readonly]="!panelStatus.isEdit"
      class="col-12"
      style="width: 400px"
      [labelWidth]="labelWidth"
      *ngIf="panelStatus.showRecurrence && !editFlorderPlanningForm.value.recurrence?.active"
    ></eps-select>

    <!-- exchange pallets -->
    <eps-checkbox
      label="ORDERS.DETAIL.LABELS.EXCHANGE_PALLETS"
      formControlName="exchangePallets"
      class="col-12"
      [labelWidth]="labelWidth"
      [readonly]="!panelStatus.isEdit || orderDetail.planning.maxAmountOfPalletExchangeAvailable === 0"
      [useIconsInReadonly]="true"
      [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
      [ngClass]="{edit: panelStatus.isEdit}"
    ></eps-checkbox>

    <eps-number-input
      label="ORDERS.DETAIL.LABELS.NUMBER_OF_EXCHANGE_PALLETS"
      formControlName="numberOfExchangePallets"
      class="col-12"
      [labelWidth]="labelWidth"
      max="10000"
      [readonly]="!panelStatus.isEdit"
      [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
      *ngIf="orderContainsCombinations && editFlorderPlanningForm.value.exchangePallets"
    ></eps-number-input>

    <eps-checkbox
      label="ORDERS.MATERIAL.LABELS.CREATE_TEMPLATE"
      formControlName="createTemplate"
      class="col-12"
      *ngIf="authorization.ORDER.CREATE_TEMPLATE && !panelStatus.isView"
      [readonly]="(!panelStatus.isEdit) || panelStatus.createTemplate || panelStatus.editTemplate"
      [useIconsInReadonly]="true"
      [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
      [labelWidth]="labelWidth"
    ></eps-checkbox>

    <eps-text-input
      label="ORDERS.MATERIAL.LABELS.TEMPLATE_NAME"
      formControlName="templateName"
      [labelWidth]="labelWidth"
      class="col-12"
      *ngIf="editFlorderPlanningForm.value.createTemplate && !panelStatus.isView"
      [readonly]="!panelStatus.isEdit"
      [showErrors]="panelStatus.isEdit || !panelStatus.isEditable"
    ></eps-text-input>
  </div>

  <div class="buttons" *ngIf="panelStatus.isEdit" id="planning-buttons">
    <div class="hr-thick"></div>
    <eps-button
      type="link"
      label="SHARED.BUTTONS.CANCEL"
      (buttonClick)="cancelClicked.emit()"
      *ngIf="panelStatus.isNew"
    ></eps-button>
    <eps-button
      buttonIcon="check"
      [label]="panelStatus.isNew ? 'ORDERS.PLANNING.BUTTONS.NEXT' : 'ORDERS.DETAIL.BUTTONS.SAVE'"
      (buttonClick)="doNextClicked()"
      [disabled]="!isValidForm()"
      submit
    ></eps-button>
  </div>
</form>
